import Vue from 'vue'
import axios from 'axios'


import {
    apiBaseURL,
    requestTimeout,
    contentType,
    page_code,
 } from '@/config'
 
import {getAccessToken } from "@/libs/accessToken";
import Notice from "@/utils/notice";
import Router from "@/router";
const service = axios.create({
    baseURL: apiBaseURL,
    timeout: requestTimeout,
    headers:{
        'Content-Type': contentType,
    }
})


axios.defaults.withCredentials=true; // 携带cookie

let loading;

service.interceptors.request.use(
    config => {
        // if(config.url === "/api/faster/index"){
        //     config.baseURL = "http://103.36.165.81:9001";
        // }
        // console.log('[ config ] >', config)
        if(config.clearLoding == undefined || config.clearLoding == false){
            loading = Vue.prototype.$baseLoading()
        }
        if(config.file){
            config.headers['Content-Type'] = 'multipart/form-data'
        }
        let token = getAccessToken();
        if(token){
            config.headers['Authori-Zation'] = token;
        }

        return config;
    },
    error => {
        
        return Promise.reject(error);
    }
)

service.interceptors.response.use(
    response => {
        if(loading) loading.close();
        const { data, config, status } = response;  // 添加status获取HTTP状态码
        const { code, msg } = data;
        console.log(code,'code');
        
        // 先检查HTTP状态码是否为500
        if (status === 500) {
            // HTTP 500错误，跳转到指定页面
            // Router.replace({ name: 'home_product' });
            return Promise.resolve(response); // 仍然返回response避免中断后续逻辑
        }
        
        // 正常业务逻辑处理
        if(Number(code) === 200){
            // 直接返回数据
            return data;
        }else if(Number(code) === 300){
            // 需要弹窗，弹出错误信息
            console.log(msg,'mgs');
         
            return  Vue.prototype.$baseNotify(msg,'fail')
        }else if(Number(code) === 400){
            //不予展示
            return Promise.reject(data);
        }else if(Number(code) === 500){
            //业务逻辑500错误，不跳转
            Promise.reject(msg)
            return data;
        }else if(Number(code) === 305){
            //业务逻辑500错误，不跳转

             Router.push({name: 'home_assessment'})
               return  Vue.prototype.$baseNotify(msg,'fail')
        }
        else if(page_code[code] !== undefined){
            // 跳转到指定页面
            Router.push({name: page_code[code]})
        }else{
            // 直接返回错误信息
            return Promise.reject(data);
        }
    },
    error => {
        const {message, response} = error;
        let msg = '';

        // 再次检查HTTP 500错误（某些情况下可能进入error拦截）
        // if (response?.status === 500) {
        //     Router.replace({ name: 'home_product' });
        //     return Promise.resolve(response);
        // }

        if(message === 'Network Error'){
            msg = '后端接口连接异常'
        }else if(message.includes('timeout')){
            msg = '后端接口请求超时'
        }else if(message.includes('Request failed with status code')){
            if(response.data.msg){
                msg = response.data.msg;
            }else{
                msg = '后端接口' + message.substr(message.length - 3) + '异常'
            }
        }
        error.msg = msg;
        return Promise.reject(error)
    }
)





export default service;